module.exports = __webpack_public_path__ + "img/hannibal.9be14617.png";